import React from 'react';
import PropTypes, { number } from 'prop-types';

import MenuItem from '~/components/core/Atomic/MenuItem';

import useOrganization from '../../OrganizationContext';
import TextFieldFormik from '../../TextFieldFormik';

import { useStyles } from '../../../assets/styles';

const SubOrganizationSelectFormik = ({
  fieldId,
  formatEntry = defaultFormatEntry,
  disabled = false,
  excludedSubOrganizationsIds,
  includedSubOrganizationsIds,
  onChange = undefined,
}) => {
  const { subOrganizationEnabled, subOrganizations } = useOrganization();
  const { classes } = useStyles();

  if (!subOrganizationEnabled) {
    return null;
  }

  let subOrganizationOptions = subOrganizations;

  if (includedSubOrganizationsIds) {
    subOrganizationOptions = subOrganizations.filter((subOrg) => includedSubOrganizationsIds.includes(subOrg.id));
  }

  if (excludedSubOrganizationsIds) {
    subOrganizationOptions = subOrganizationOptions.filter(
      (subOrg) => !excludedSubOrganizationsIds.includes(subOrg.id)
    );
  }

  subOrganizationOptions = [...subOrganizationOptions].sort((a, b) =>
    (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' })
  );

  return (
    <TextFieldFormik
      id={fieldId}
      label="Sub Organization"
      className={classes.textField}
      select
      fullWidth
      disabled={disabled}
      onChange={onChange}
    >
      {subOrganizationOptions.map((subOrg) => (
        <MenuItem key={subOrg.id} value={subOrg.id}>
          {formatEntry(subOrg)}
        </MenuItem>
      ))}
    </TextFieldFormik>
  );
};

const defaultFormatEntry = (subOrganization) => subOrganization.name;

SubOrganizationSelectFormik.propTypes = {
  fieldId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  formatEntry: PropTypes.func,
  excludedSubOrganizationsIds: PropTypes.arrayOf(number),
  includedSubOrganizationsIds: PropTypes.arrayOf(number),
  onChange: PropTypes.func,
};

export default SubOrganizationSelectFormik;
